var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import React from 'react';
import { defaultProps } from './defaults';
import { SpanTag } from '../../Utils/AtomicTag';
import { CloseOutlined } from '@feb-team/legao-icons-react';
var Tag = /** @class */ (function (_super) {
    __extends(Tag, _super);
    function Tag(props) {
        var _this = _super.call(this, props) || this;
        /*
         * 关闭事件，并调用props的回调
         * */
        _this.close = function (e) {
            _this.setState({
                isVisible: false,
            });
            _this.props.onClose(e);
        };
        _this.state = {
            isVisible: props.visible,
        };
        return _this;
    }
    Tag.prototype.generateUI = function () {
        // 默认为空心，使用 isFill 属性控制是否实心
        var typeAtomics = {
            default: {
                outline: ['border-gray-300', 'bg-gray-50', 'text-black'],
                fill: ['border-gray-300', 'bg-gray-300', 'text-black'],
            },
            info: {
                outline: ['border-brand-600', 'bg-brand-10', 'text-brand-600'],
                fill: ['border-brand-600', 'bg-brand-600', 'text-white'],
            },
            warning: {
                outline: ['border-warn-900', 'bg-warn-800', 'text-warn-900'],
                fill: ['border-warn-900', 'bg-warn-900', 'text-white'],
            },
            error: {
                outline: ['border-error-900', 'bg-gray-50', 'text-error-900'],
                fill: ['border-error-900', 'bg-error-900', 'text-white'],
            },
            success: {
                outline: ['border-succ-900', 'bg-succ-800', 'text-succ-900'],
                fill: ['border-succ-900', 'bg-succ-900', 'text-white'],
            },
        };
        // 处理type的样式
        var uiType = this.props.type;
        // 是否增加填充色
        var typeClassName = this.props.isFill
            ? typeAtomics[uiType]['fill']
            : typeAtomics[uiType]['outline'];
        return { shapeClassName: this.props.shape, typeClassName: typeClassName };
    };
    /*
     * 根据 props 来组合样式
     * */
    Tag.prototype.generatePreset = function () {
        var atomics = [
            'border',
            'border-solid',
            'px-2',
            'h-px-24',
            'inline-flex',
            'items-center',
            'text-sm',
        ];
        // 生成预设形状的 className 和 UIType 的 className
        var _a = this.generateUI(), shapeClassName = _a.shapeClassName, typeClassName = _a.typeClassName;
        // 自定义 style
        var colorStyle = this.props.style || this.generateColorStyle();
        return {
            presetClassName: [shapeClassName, this.props.className].join(' '),
            atomics: __spread([
                (shapeClassName == 'rounded' ? 'rounded' : '')
            ], atomics, typeClassName),
            colorStyle: colorStyle,
        };
    };
    /*
     * 获取指定 color 属性的样式
     * */
    Tag.prototype.generateColorStyle = function () {
        // 自定义 style
        return this.props.color
            ? {
                backgroundColor: this.props.color,
                borderColor: this.props.color,
                color: 'white',
            }
            : {};
    };
    /*
     * 获取异形标签的 className 和 style 属性值
     * */
    Tag.prototype.generateTadpoleClassAndStyle = function () {
        // 自定义 style
        var colorStyle = this.generateColorStyle();
        var _a = this.generateUI(), shapeClassName = _a.shapeClassName, typeClassName = _a.typeClassName;
        if (this.props.shape === 'tadpole') {
            return {
                className: __spread([shapeClassName], typeClassName).join(' '),
                style: colorStyle,
            };
        }
        return {};
    };
    Tag.prototype.renderClose = function () {
        var close = this.props.close;
        var iconAtomics = ['fill-gray-400'];
        if (typeof close == 'boolean' && !close) {
            return React.createElement(React.Fragment, null);
        }
        else if (typeof close == 'boolean' && close === true) {
            return (React.createElement(SpanTag, { className: "legao-tag-close ", atomics: ['cursor-pointer'], onClick: this.close },
                React.createElement(CloseOutlined, null)));
        }
        else if (React.isValidElement(close)) {
            return (React.createElement(SpanTag, { className: "legao-tag-close ", atomics: ['cursor-pointer'], onClick: this.close }, close));
        }
        console.warn('close prop [%s] not valid.', close);
    };
    Tag.prototype.render = function () {
        var isVisible = this.state.isVisible;
        var tadpole = this.generateTadpoleClassAndStyle();
        var _a = this.generatePreset(), presetClassName = _a.presetClassName, atomics = _a.atomics, colorStyle = _a.colorStyle;
        var _b = this.props, children = _b.children, icon = _b.icon, shape = _b.shape, style = _b.style, className = _b.className, rest = __rest(_b, ["children", "icon", "shape", "style", "className"]);
        if (!isVisible)
            return null;
        return (React.createElement(SpanTag, __assign({}, rest, { name: Tag.NAME, atomics: atomics, className: presetClassName, style: colorStyle }),
            icon ? icon : null,
            React.createElement(SpanTag, { atomics: ['leading-none'], autoPrefixedClassName: "tag-content" }, children),
            shape == 'tadpole' && React.createElement("i", { style: tadpole.style, className: tadpole.className }),
            this.renderClose()));
    };
    // 默认参数，单独从外部文件引入
    Tag.defaultProps = defaultProps;
    Tag.NAME = 'tag';
    Tag.displayName = 'Tag';
    return Tag;
}(React.Component));
export { Tag };
